import { Grid, useMediaQuery, useTheme } from "@mui/material";
// import { useRef, useState, useEffect } from "react";
import PersonCard from "./PersonCard";
import { peopleContent } from "../../data/peopleContent";

const PeopleGrid: React.FC = () => {
  // const refs = useRef<(HTMLDivElement | null)[]>([]);
  // const [maxHeight, setMaxHeight] = useState(0);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const fixedHeight = 310;
  // const setRef = (el: HTMLDivElement | null, index: number) => {
  //   refs.current[index] = el;
  // };

  // useEffect(() => {
  //   if (!isMobile) {
  //     const heights = refs.current.map((el) => el?.scrollHeight || 0);
  //     const max = Math.max(...heights);
  //     setMaxHeight(max);
  //   } else {
  //     setMaxHeight(0); // en mobile lo ignoramos
  //   }
  // }, [isMobile, peopleContent.team]);

  return (
    <Grid
      container
      spacing={{ xs: 2, md: 6 }}
      sx={{
        m: 0,
      }}
    >
      {peopleContent.team.map((person, index) => (
        <Grid size={{ xs: 12, sm: 6, md: 4 }} key={index}>
          <PersonCard
            name={person.name}
            role={person.role}
            image={person.imageSrc}
            imageAlt={person.imageAlt}
            description={person.bio}
            grayscale={true}
            // index={index}
            // setRef={setRef}
            // maxHeight={maxHeight}
            fixedHeight={fixedHeight}
            isMobile={isMobile}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default PeopleGrid;
